var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-component"},[_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"chart"},[_c('apexchart',{key:_vm.chartComponentKey,ref:"apexChartRef",attrs:{"height":"315","options":_vm.chartOptions,"series":_vm.chartSeries},on:{"mousedown":_vm.disableTooltip,"mouseup":_vm.enableTooltip}})],1),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }